<div class="modal-header">
  <h4 class="modal-title">News</h4>
</div>
<div class="modal-body" style="overflow-y: auto; max-height: 600px">
  <ch-news-list></ch-news-list>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Close</button>
</div>
